import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { PaymentsListItemAmount } from "../../Earnings/components/PaymentsListItemAmount";
import { PaymentsListItemDescription } from "../../Earnings/components/PaymentsListItemDescription";
import { PaymentsListItemPill } from "../../Earnings/components/PaymentsListItemPill";
import { PaymentsListItemTitle } from "../../Earnings/components/PaymentsListItemTitle";
import { type PaymentsListItem } from "../../Earnings/types/PaymentsListItem";
import { formatPaymentDetailsDateWithTime } from "../utils/dates";

export interface PaymentDetailsHeaderProps {
  item: PaymentsListItem;
}

export function PaymentDetailsHeader(props: PaymentDetailsHeaderProps) {
  const { item } = props;
  const paymentDate = new Date(item.attributes.createdAt);

  return (
    <Stack spacing={5}>
      <Stack direction="row" spacing={4} sx={{ alignItems: "center" }}>
        <PaymentsListItemPill item={item} compact={false} />
        <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
          {formatPaymentDetailsDateWithTime(paymentDate)}
        </Text>
      </Stack>
      <Stack spacing={4}>
        <PaymentsListItemAmount item={item} compact={false} />
        <PaymentsListItemTitle item={item} compact={false} />
        <PaymentsListItemDescription item={item} />
      </Stack>
    </Stack>
  );
}
